<template>
	<article class="category-review">
		<form @submit.prevent="search">
			<managing-section>
				<managing-box title="기간">
					<DateRange v-model="datePeriod" type="date" />
				</managing-box>
			</managing-section>
			<div class="btn-wrap-main">
				<button type="submit" class="btn-main blue" v-text="'검색'" />
			</div>
		</form>
		<managing-section :isTable="true">
			<template slot="infoSection">
				<div class="section__info__left"></div>
				<div class="section__info__right">
					<button
						class="btn-excel section__info__items"
						type="button"
						@click="excelDown"
					>
						엑셀 다운로드
					</button>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th v-for="th in thList" :key="th">{{ th }}</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, idx) in list" :key="idx">
						<td class="category-review__table__idx">
							{{ idx + 1 }}
						</td>
						<td class="category-review__table__id">
							{{ item.idSecondCategory }}
						</td>
						<td class="category-review__table__title">
							{{ item.secondCategoryText }}
						</td>
						<td class="category-review__table__review">
							{{ item.reviewCnt | currency }}
						</td>
					</tr>
				</tbody>
			</table>
		</managing-section>
	</article>
</template>

<script>
	import moment from 'moment';
	import util from '@/util.js';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import DateRange from '@/components/DateRange';

	export default {
		name: 'CategoryReview',
		components: { ManagingSection, ManagingBox, DateRange },
		data() {
			return {
				datePeriod: { from: '', to: '' },
				list: [],
				thList: ['No', '카테고리 항번', '카테고리 명', '리뷰 수'],
				lastApiUrl: '',
			};
		},
		watch: {
			'$route.query'(query) {
				this.setFilter(query);
			},
		},
		mounted() {
			this.setFilter(this.$route.query);
		},
		methods: {
			search() {
				const query = {
					from: this.datePeriod.from || null,
					to: this.datePeriod.to || null,
				};
				this.$router.replace({ query }).catch(() => {
					window.location.reload();
				});
			},
			parseDate(date) {
				return date ? date.replaceAll('-', '') : '';
			},
			async getList() {
				try {
					const params = {
						from: this.parseDate(this.datePeriod.from),
						to: this.parseDate(this.datePeriod.to),
					};
					const { config, data } = await this.$axiosAdmin2.get(
						'/api/analysis/reviews/category/stats',
						{ params }
					);
					this.lastApiUrl = config.url;
					this.list = data.stats;
				} catch (err) {
					console.error(err);
					alert('카테고리 목록을 불러오는데 실패했습니다.');
				}
			},
			setFilter(query) {
				this.datePeriod = {
					from: query.from || '',
					to: query.to || '',
				};
				this.list = [];
				if (query.from || query.to) this.getList();
			},
			excelDown() {
				try {
					const rows = this.list.map((item, idx) => [
						idx + 1,
						item.idSecondCategory,
						item.secondCategoryText,
						util.currency(item.reviewCnt.toString()),
					]);
					const title = `${this.parseDate(this.datePeriod.from)} ~ ${this.parseDate(this.datePeriod.to)}`;
					util.getCsv(
						[rows],
						[title],
						[this.thList],
						`${title.replace(' ~ ', '-')}_${new Date().getTime()}`,
						this.lastApiUrl
					);
				} catch (err) {
					console.error(err);
					alert(
						'엑셀 파일을 다운로드하는데 실패했습니다. 개발팀에 문의하세요.'
					);
				}
			},
		},
	};
</script>

<style lang="scss" scoped>
	.category-review {
		.category-review__table__idx,
		.category-review__table__id,
		.category-review__table__title {
			text-align: left;
		}

		.category-review__table__review {
			text-align: right;
		}
	}
</style>
